<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div class="panel" v-loading="loading">
      <sll-table
        :changeHeight="true"
        :downLoadTran="downLoadTran"
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :pageEnable="false"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="requestEngine"
      >
        <div class="search-box" slot="search">
          <div class="select-type">
            <span v-text="lan.bGroup"></span>
            <el-input clearable style="width:150px;" v-model="group"></el-input>
          </div>
          <div class="select-type">
            <span v-text="lan.aAccount"></span>
            <el-input clearable style="width:150px;" v-model="account"></el-input>
          </div>
          <div class="select-type">
            <el-button @click="requestEngine" type="primary" v-text="reuse.searchText"></el-button>
          </div>
        </div>
      </sll-table>
    </div>
  </div>
</template>

<script>
import { URL_BBOOKREPORT } from 'api/api'
import sllTable from 'components/reuseTable'

export default {
  mixins: [require('common/mixin/base').base({ lan: 'bBookReport' }), require('common/mixin/base').base({ reuse: 'reuse' })],
  data() {
    return {
      tbodyData: [],
      group: 'BUK',
      account: '400021',
      loading: false,
    }
  },
  components: {
    sllTable,
  },
  created() {
    this.requestEngine()
  },
  computed: {
    downLoadTran() {
      return { SYMBOL: this.lan.sum }
    },
    tableHead() {
        const redColorColumns = ['B_NET_VOLUME','B_PROFIT','A_NET_VOLUME','A_PROFIT','NET_PROFIT']
        this.lan.tableHead.forEach(head => {
            if(redColorColumns.includes(head.key)) head.redColor = true;
        })
        return this.lan.tableHead
    },
    name() {
      return this.lan.downloadName
    },
    jsonExcelAjax() {
      return {
        url: URL_BBOOKREPORT,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        ajaxPar: {
          group: this.group,
          account: this.account,
        },
      }
    },
  },
  methods: {
    requestEngine() {
      if (!this.account) {
        this.$message({ message: this.lan.tip, type: 'warning' })
        return
      }
      this.loading = true
      let option = { params: { group: this.group, account: this.account } }
      this.$http
        .get(URL_BBOOKREPORT, option)
        .then((res) => {
          if (Object.prototype.toString.call(res.data.data) === '[object Array]') this.tbodyData = res.data.data
          else this.tbodyData = []
          this.tbodyData.forEach((v, i) => {
            if (i == this.tbodyData.length - 1) v.SYMBOL = this.lan.sum[v.SYMBOL]
          })
          this.loading = false
        })
        .catch((e) => {
          alert(this.reuse.serverError)
          this.loading = false
        })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/views/report/b-book-report.vue